import { render, staticRenderFns } from "./station-detail-price.vue?vue&type=template&id=1bd1759c&scoped=true&"
import script from "./station-detail-price.vue?vue&type=script&lang=js&"
export * from "./station-detail-price.vue?vue&type=script&lang=js&"
import style0 from "./station-detail-price.vue?vue&type=style&index=0&id=1bd1759c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd1759c",
  null
  
)

export default component.exports